export interface CarouselDotsProps {
  /** Total number of dots to render. */
  count: number;
  /** Index (0-based) of the active dot, rendered as a pill. */
  active: number;
  className?: string;
}

/**
 * Presentational carousel position indicator: `count` dots, one active pill.
 * Non-interactive — purely decorative, so it is hidden from assistive tech.
 */
export function CarouselDots({ count, active, className }: CarouselDotsProps) {
  return (
    <div
      aria-hidden
      className={['flex items-center justify-center gap-1.5', className]
        .filter(Boolean)
        .join(' ')}
    >
      {Array.from({ length: count }, (_, i) => (
        <span
          key={i}
          data-dot
          className={[
            'h-2 rounded-full transition-all',
            i === active ? 'w-5 bg-primary' : 'w-2 bg-surface-muted',
          ].join(' ')}
        />
      ))}
    </div>
  );
}
